import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import NewSubmission from './pages/NewSubmission';
import ViewSubmission from './pages/ViewSubmission';
import EditSubmission from './pages/EditSubmission';
import MyInfo from './pages/MyInfo';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router basename="/submission">
          <Navbar />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/my-info"
              element={
                <PrivateRoute>
                  <MyInfo />
                </PrivateRoute>
              }
            />
            <Route
              path="/submissions/new"
              element={
                <PrivateRoute>
                  <NewSubmission />
                </PrivateRoute>
              }
            />
            <Route
              path="/submissions/:id"
              element={
                <PrivateRoute>
                  <ViewSubmission />
                </PrivateRoute>
              }
            />
            <Route
              path="/submissions/:id/edit"
              element={
                <PrivateRoute>
                  <EditSubmission />
                </PrivateRoute>
              }
            />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App; 